import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';
import React from 'react';

export const TireIcon = ({
  width = 24,
  height = 24,
  color: colorProps,
  fill: fillProps,
  hovered,
  strokeWidth
}: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProps || defaultColor;
  const fill = defaultFill || fillProps;

  return (
    <svg width={width} height={height} viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      {hovered && (
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.8545 12C21.8545 16.9706 17.8251 21 12.8545 21C7.88393 21 3.85449 16.9706 3.85449 12C3.85449 7.02944 7.88393 3 12.8545 3C17.8251 3 21.8545 7.02944 21.8545 12ZM19.2295 12C19.2295 15.5208 16.3753 18.375 12.8545 18.375C9.33368 18.375 6.47949 15.5208 6.47949 12C6.47949 8.47918 9.33368 5.625 12.8545 5.625C16.3753 5.625 19.2295 8.47918 19.2295 12Z'
          fill={fill}
        />
      )}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.34297 13.0635L7.18506 14.6181L7.80415 15.6854L10.2328 14.5871C11.0062 14.2391 11.8879 14.7495 11.973 15.5926L12.236 18.2378L13.4731 18.2455L13.7361 15.6003C13.8211 14.7573 14.7029 14.2468 15.4763 14.5949L17.9049 15.6932L18.5238 14.6181L16.3659 13.0635C15.6775 12.5685 15.6775 11.5476 16.3659 11.0526L18.5238 9.49796L17.9049 8.43061L15.4763 9.5289C14.7029 9.87695 13.8211 9.36648 13.7361 8.52342L13.4731 5.87051L12.236 5.87825L11.973 8.52343C11.8879 9.36648 11.0062 9.87695 10.2328 9.5289L7.80415 8.43062L7.18506 9.49796L9.34297 11.0526C10.0313 11.5476 10.0313 12.5685 9.34297 13.0635ZM14.0154 12C14.0154 12.6413 13.4955 13.1613 12.8541 13.1613C12.2127 13.1613 11.6928 12.6413 11.6928 12C11.6928 11.3586 12.2127 10.8387 12.8541 10.8387C13.4955 10.8387 14.0154 11.3586 14.0154 12Z'
        fill='white'
      />
      <path
        d='M12.8545 21C17.8251 21 21.8545 16.9706 21.8545 12C21.8545 7.02944 17.8251 3 12.8545 3C7.88393 3 3.85449 7.02944 3.85449 12C3.85449 16.9706 7.88393 21 12.8545 21Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M12.8545 18.375C16.3753 18.375 19.2295 15.5208 19.2295 12C19.2295 8.47918 16.3753 5.625 12.8545 5.625C9.33368 5.625 6.47949 8.47918 6.47949 12C6.47949 15.5208 9.33368 18.375 12.8545 18.375Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M12.8544 13.1613C13.4958 13.1613 14.0157 12.6413 14.0157 12C14.0157 11.3586 13.4958 10.8387 12.8544 10.8387C12.213 10.8387 11.6931 11.3586 11.6931 12C11.6931 12.6413 12.213 13.1613 12.8544 13.1613Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M13.4397 17.8543L13.6885 15.3516C13.769 14.5539 14.6033 14.071 15.3351 14.4003L17.6329 15.4394'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.07593 8.56789L10.3738 9.60704C11.1056 9.93635 11.9398 9.45336 12.0203 8.6557L12.2691 6.15295'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.07593 15.4321L10.3738 14.3929C11.1056 14.0636 11.9398 14.5466 12.0203 15.3443L12.2691 17.847'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.2184 9.57776L16.1767 11.0487C15.5254 11.517 15.5254 12.483 16.1767 12.9513L18.2184 14.4223'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.6329 8.56788L15.3351 9.60703C14.6033 9.93634 13.769 9.45336 13.6885 8.6557L13.4397 6.14563'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.49023 14.4223L9.53195 12.9513C10.1833 12.483 10.1833 11.517 9.53195 11.0487L7.49023 9.57776'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.2343 5.64914C19.2198 5.76527 19.14 5.99753 18.8279 5.99753'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.56885 18.4452C6.56885 18.0315 7.01159 18.0024 7.01159 18.0024'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.0706 14.1194C21.223 14.3806 21.448 14.3371 21.5569 14.3008'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.14478 9.72822C4.50042 9.525 4.76897 9.88064 4.76897 9.88064'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.1623 20.1145C14.9881 20.4193 15.2203 20.6153 15.2929 20.6588'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6771 3.88542C10.6771 3.88542 10.8803 3.508 10.5247 3.30478'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.0388 3.84913C15.3437 3.67494 15.2348 3.38462 15.1985 3.30478'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.648 20.7242C10.4448 20.3685 10.8077 20.1435 10.8077 20.1435'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.0342 9.75723C21.2882 9.90239 21.4697 9.76449 21.5495 9.67014'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.18115 14.4169C4.38438 14.0612 4.80534 14.2427 4.80534 14.2427'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.2705 18.3145C19.1544 18.3 18.9221 18.2201 18.9221 17.9081'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.47485 5.64914C6.88856 5.64914 6.91759 6.09188 6.91759 6.09188'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9792 16.3903L16.4147 17.1015'
        stroke={color}
        strokeMiterlimit='10'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
    </svg>
  );
};
